import React, { FC, ReactNode } from 'react'
import { Provider } from 'react-redux'
import { createStore as reduxCreateStore } from 'redux'
import { reducer } from './reducer'

const createStore = () => reduxCreateStore(reducer)
export const store = createStore()

interface AppProviderProps {
  children: ReactNode
}

export const AppProvider: FC<AppProviderProps> = ({ children }) => (
  <Provider store={store}>{children}</Provider>
)
